import { Box, Typography } from '@mui/material';
import Pin from '@shared/assets/logos/pin';

const SellerBlock = ({ seller, screenWidth }) =>
  !!seller?.name && (
    <Box>
      <Box display="flex" alignItems="center" mb={1}>
        <Pin
          width={screenWidth < 600 ? 17 : 33}
          height={screenWidth < 600 ? 16 : 31}
        />
        <Typography sx={{ color: '#000', fontWeight: 600 }} ml={1}>
          Vendedor
        </Typography>
      </Box>
      <Typography>
        {`${seller.name} ${seller.last_name} (${seller.email})`}
      </Typography>
    </Box>
  );

export default SellerBlock;
